import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import LastMessage from 'components/chat/sidebar/LastMessage';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

export const MessageThread = ({ thread }) => {
  const navigate = useNavigate();
  const { client: user, lastMessage, id } = thread;

  const handleAvatarUrl = () => {
    if (user.photo) {
      return user.photo.match(/http/)
        ? user.photo
        : `${process.env.REACT_APP_CLIENT}/uploads/clients/profile-pictures/${user.photo}`;
    }
  };
  return (
    <div
      className={classNames(`chat-contact hover-actions-trigger p-3`, {
        'unread-message': !thread.read_at,
        'read-message': thread.read_at
      })}
      onClick={() => {
        navigate(`/mensajes?cid=${id}`);
      }}
      style={{ cursor: 'pointer' }}
    >
      <Flex>
        <Avatar
          className={user.status}
          src={handleAvatarUrl()}
          name={`${user.firstName} ${user.lastName}`}
          size="xl"
        />

        <div
          className={classNames(
            'flex-1 chat-contact-body ms-2 d-lg-block opacity-lg-100 ms-lg-2'
          )}
          style={{
            transition: 'all 0.3s ease-in'
          }}
        >
          <Flex justifyContent="between">
            <h6 className="mb-0 chat-contact-title">{`${user.firstName} ${user.lastName}`}</h6>

            <span className="message-time fs--2">
              {' '}
              {!!lastMessage &&
                dayjs(lastMessage.created_at).format(
                  dayjs().isSame(lastMessage.created_at, 'day')
                    ? 'HH:mm'
                    : 'DD/MM/YYYY'
                )}{' '}
            </span>
          </Flex>

          <div className="min-w-0">
            <div
              className={classNames('chat-contact-content pe-3', {
                'fw-normal': !!lastMessage?.read_at || !!lastMessage?.user
              })}
            >
              <LastMessage lastMessage={lastMessage} thread={thread} />

              <div className="position-absolute bottom-0 end-0 hover-hide">
                {!!lastMessage?.read_at && !!lastMessage?.user && (
                  <FontAwesomeIcon
                    icon="check-double"
                    transform="shrink-5 down-4"
                    className="text-primary"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Flex>
    </div>
  );
};
MessageThread.propTypes = {
  thread: PropTypes.object.isRequired
};
